import axios from '@/plugins/axios'

export default {
// Aplicamos el error handler
  async logError(message) {
    try {
      await axios
        .post(`${process.env.VUE_APP_API_ENDPOINT}/logs`,
          { message })
    } catch (ex) {
      console.error(ex)
    }
  },
}
